import { DECISIONING_DASHBOARD_ACTIONS } from "../constants/actions";

export function fetchDesisioningDashboardColumns() {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_COLUMNS,
    };
}

export function fetchedDesisioningDashboardColumns(columns) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_COLUMNS,
        payload: {
            columns
        }
    };
}

export function failedFetchDesisioningDashboardColumns(error) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_COLUMNS,
        error
    };
}

export function fetchDesisioningDashboardRows(page, pageSize, filters, stageId) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_ROWS,
        payload: {
            page, 
            filters,
            pageSize,
            stageId
        }
    };
}

export function fetchedDesisioningDashboardRows(page, pageSize, filters, rows, stageId) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_ROWS,
        payload: {
            page, 
            filters,
            rows,
            pageSize,
            stageId
        }
    };
}

export function failedFetchDesisioningDashboardRows(page, pageSize, filters, error, stageId) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_ROWS,
        payload: {
            page, 
            filters,
            pageSize,
            stageId
        },
        error
    };
}



export function fetchDesisioningDashboardProceed(case_task_ids, this_stage, this_user, remark, page, pageSize, filters, stageId) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_PROCEED,
        payload: {
            case_task_ids, 
            this_stage, 
            this_user,
            remark,
            page, 
            filters,
            pageSize,
            stageId
        }
    };
}

export function fetchedDesisioningDashboardProceed(case_task_ids, this_stage, this_user, remark, page, pageSize, filters, resposne) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_PROCEED,
        payload: {
            case_task_ids, 
            this_stage, 
            this_user,
            remark,
            page, 
            filters,
            pageSize,
            resposne
        }
    };
}

export function failedFetchDesisioningDashboardProceed(case_task_ids, this_stage, this_user, remark, page, pageSize, filters, error) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_PROCEED,
        payload: {
            case_task_ids, 
            this_stage, 
            this_user,
            remark,
            page, 
            filters,
            pageSize,
        },
        error
    };
}


export function fetchDesisioningDashboardRefer(case_task_ids, this_stage, this_user, remark, page, pageSize, filters, stageId) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_REFER,
        payload: {
            case_task_ids, 
            this_stage, 
            this_user,
            remark,
            page, 
            filters,
            pageSize,
            stageId
        }
    };
}

export function fetchedDesisioningDashboardRefer(case_task_ids, this_stage, this_user, remark, page, pageSize, filters, resposne) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_REFER,
        payload: {
            case_task_ids, 
            this_stage, 
            this_user,
            remark,
            page, 
            filters,
            pageSize,
            resposne
        }
    };
}

export function failedFetchDesisioningDashboardRefer(case_task_ids, this_stage, this_user, remark, page, pageSize, filters, error) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_REFER,
        payload: {
            case_task_ids, 
            this_stage, 
            this_user,
            remark,
            page, 
            filters,
            pageSize,
        },
        error
    };
}


export function fetchDesisioningDashboardSanction(caseIds, sanctionConditionObj, page, pageSize, filters, stageId) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_SANCTION,
        payload: {
            caseIds, 
            sanctionConditionObj, 
            page, 
            pageSize, 
            filters,
            stageId
        }
    };
}

export function fetchedDesisioningDashboardSanction(caseIds, sanctionConditionObj, page, pageSize, filters, resposne) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_SANCTION,
        payload: {
            caseIds, 
            sanctionConditionObj, 
            page, 
            pageSize, 
            filters,
            resposne
        }
    };
}

export function failedFetchDesisioningDashboardSanction(caseIds, sanctionConditionObj, page, pageSize, filters, error) {
    return {
        type: DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_SANCTION,
        payload: {
            caseIds, 
            sanctionConditionObj, 
            page, 
            pageSize, 
            filters,
        },
        error
    };
}

